import { SVGProps } from '@components/Icon/types';

export const RecruitmentTeam = ({
  fill = '#000',
  size = 24,
  ...props
}: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(2, 2)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.03075 3.22505C9.75657 3.22515 11.1591 4.62324 11.1597 6.34587V6.35093C11.1499 8.02907 9.82596 9.40208 8.14408 9.4596C8.10921 9.46075 8.07349 9.45742 8.03884 9.45353L8.03277 9.45455L7.91842 9.4596C6.24003 9.40228 4.90284 8.03117 4.90284 6.34587C4.90338 4.62487 6.29639 3.22544 8.03075 3.22505ZM8.03075 4.66504C7.09469 4.66543 6.34539 5.41801 6.34486 6.34587C6.34486 7.2417 7.04655 7.97209 7.93664 8.0186C7.99769 8.01461 8.0623 8.01448 8.12587 8.0186C9.01149 7.97218 9.71124 7.24604 9.71765 6.34486L9.70854 6.17384C9.62148 5.32772 8.9028 4.66513 8.03075 4.66504Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.97813 0C12.3705 0 15.9561 3.58576 15.9563 7.97813C15.9563 9.7775 15.3477 11.4364 14.3331 12.7757L14.1429 13.0277L19.7571 18.643C19.8327 18.7155 19.8936 18.8028 19.9352 18.899C19.9768 18.9952 19.9989 19.0988 20 19.2036C20.001 19.3082 19.9808 19.4122 19.9413 19.5092C19.9017 19.6062 19.8433 19.6951 19.7692 19.7692C19.6951 19.8434 19.6062 19.9017 19.5092 19.9413C19.4122 19.9808 19.3083 20.001 19.2036 20C19.0988 19.9989 18.9952 19.9768 18.899 19.9352C18.8028 19.8936 18.7155 19.8327 18.643 19.7571L13.0277 14.1429L12.7757 14.3331C11.4364 15.3477 9.7775 15.9563 7.97813 15.9563C3.58574 15.9561 0 12.3705 0 7.97813C0.000142498 3.58583 3.58583 0.000125293 7.97813 0ZM8.03581 11.4035C6.82288 11.4037 5.64488 11.712 4.78242 12.2829C4.43034 12.5197 4.18595 12.7744 4.02853 13.0247C5.1148 13.8745 6.48436 14.3806 7.97813 14.3807C9.50335 14.3807 10.8955 13.8479 11.9915 12.965C11.8335 12.7336 11.6019 12.499 11.277 12.2809C10.4229 11.7114 9.24909 11.4036 8.03581 11.4035ZM7.97813 1.57559C4.42871 1.57571 1.57573 4.42871 1.57559 7.97813C1.57559 9.5053 2.10483 10.9031 2.98927 12.0006C3.25137 11.6596 3.5859 11.3514 3.97996 11.0868L3.98097 11.0858L3.984 11.0848C5.13212 10.3242 6.60405 9.9647 8.03581 9.96456C9.4674 9.96459 10.9375 10.3238 12.0795 11.0858L12.0805 11.0868C12.4474 11.3331 12.7631 11.6168 13.0166 11.9297C13.8694 10.8436 14.3807 9.47426 14.3807 7.97813C14.3805 4.42864 11.5277 1.57559 7.97813 1.57559Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'recruitment-team';
